<template>
  <!-- 用户上级管理 -->
  <div>
    <!-- <el-row>
      <el-col class="pull-left" style="width: 200px; margin-right: 20px">
        <el-input
          size="small"
          v-model="query.uid"
          placeholder="用户UID"
        ></el-input>
      </el-col>
      <el-col class="pull-left" style="width: 200px; margin-right: 20px">
        <el-input
          size="small"
          v-model="query.name"
          placeholder="用户名称"
        ></el-input>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="query.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="query.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-button
        size="small"
        class="pull-left"
        type="primary"
        @click="handleSearch"
        >搜索
      </el-button>
    </el-row> -->
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="old_superior_id" label="老上级"></el-table-column>
      <el-table-column prop="new_superior_id" label="新上级"></el-table-column>
      <el-table-column prop="updated_at" label="绑定时间"></el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import { getApiData } from '@/http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      query: {
        page:1
      }
    }
  },

  methods: {
    handleSearch() {
      this.query.page = 1
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      getApiData(`user_superiors/${this.id}`)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getTableData()
    },
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
